import React, { useMemo } from "react"

import { NETWORK_STATUS_CONFIG } from "../../../config/networkStatus.config"
import { RuntimeHelper } from "../../../helpers/runtime.helper"
import { useAppDispatch } from "../../../store/appDispatch.hook"
import { useAppSelector } from "../../../store/selectors/app.selector"
import { networkStatusSelector } from "../../../store/selectors/networkStatus.selector"
import { runtimeSelector } from "../../../store/selectors/runtime.selector"
import { selectedPracticeRoleSelector } from "../../../store/selectors/selectedPracticeRole.selector"
import { networkStatusExportRulesList } from "../../../store/thunks/networkStatus.thunks"
import { CsvActionsDropdownComponent } from "../../general/csvUploads/csvActionsDropdown.component"

export const RulesListCsvDropdownComponent: React.FunctionComponent<
    IRulesListCsvDropdownComponentProps
> = props => {
    const dispatch = useAppDispatch()

    const selectedPracticeRole = useAppSelector(selectedPracticeRoleSelector)
    const networkStatusState = useAppSelector(networkStatusSelector)
    const runtimeState = useAppSelector(runtimeSelector)

    const isExportLoading = useMemo<boolean>(() => {
        return RuntimeHelper.isNetworkStatusExportRulesLoading()
    }, [runtimeState.isLoading])

    const handleDownloadRulesAsCsv = () => {
        if (!selectedPracticeRole || !props.selectedRulesVersion) {
            return
        }

        dispatch(
            networkStatusExportRulesList({
                practice: selectedPracticeRole.practice,
                payload: {
                    version: props.selectedRulesVersion,
                    filters: networkStatusState.filters,
                },
            }),
        )
    }

    return (
        <CsvActionsDropdownComponent
            canUpload
            templateUrl={NETWORK_STATUS_CONFIG.csvTemplateUrl}
            uploadLabel="Upload rules with CSV"
            onUpload={props.onOpenBulkUpload}
            downloadLabel="Download rules as CSV"
            onDownload={handleDownloadRulesAsCsv}
            isDownloadDisabled={!props.selectedRulesVersion}
            isExportLoading={isExportLoading}
            exportProgress={networkStatusState.exportProgress}
        />
    )
}

interface IRulesListCsvDropdownComponentProps {
    selectedRulesVersion: number | null
    onOpenBulkUpload: () => void
}
